import { io } from "socket.io-client";

const socket =io('https://femaissance-backend.onrender.com/',{
  reconnection:false
});

export default socket;